import Mergers from './Mergers'

export default Mergers
